import { getReturnUrl, PropertyPanel, resolveUrl, serviceCall } from "@serenity-is/corelib";
import { ElevationFormTexts } from "../ServerTypes/Texts";
import { ElevateRequest } from "../ServerTypes/Pro/Extensions.ElevateRequest";
import { ElevateForm } from "../ServerTypes/Pro/Extensions.ElevateForm";

export default function pageInit() {
    new ElevationPanel({ element: '#PanelDiv' }).domNode?.classList.add("d-flex", "flex-grow-1", "align-items-center");
}

export class ElevationPanel extends PropertyPanel<ElevateRequest, any> {

    protected getFormKey() {
        return ElevateForm.formKey;
    }

    protected redirectToReturnUrl() {
        window.location.href = getReturnUrl({ purpose: "elevation" });
    }

    submitClick() {
        if (!this.validateForm()) {
            return;
        }

        var request = this.propertyGrid.save();

        serviceCall({
            url: resolveUrl('~/Account/Elevate'),
            request,
            onSuccess: () => {
                this.redirectToReturnUrl()
            }
        });
    }

    renderContents(): any {
        const id = this.useIdPrefix();
        return (
            <div class="s-container-tight">
                <div class="s-Panel p-4">
                    <h5 class="text-center mb-4">{ElevationFormTexts.ConfirmAccess}</h5>
                    <p class="text-center">{ElevationFormTexts.ActionRequiresElevation}</p>
                    <form id={id.Form} action="">
                        <div id={id.PropertyGrid}></div>
                        <button id={id.SubmitButton} type="submit" class="btn btn-primary my-3 mx-8 w-100"
                            onClick={e => {
                                e.preventDefault();
                                this.submitClick()
                            }}>
                            {ElevationFormTexts.ElevateButton}
                        </button>
                    </form>
                </div>
            </div>
        )
    }
}

